import { IconName } from 'src/app/features/shared/icons/icon-registry';
import { IAutoComplete } from './auto-complete.model';

// Optie van een button-toggle: IAutoComplete (itemId = waarde, itemText = tekst) met optioneel een icoon vóór de tekst.
export interface IToggleOption extends IAutoComplete {
    icon?: IconName;
}

export function toggleOption_icon(item: IToggleOption | string): IconName | undefined {
    return typeof item === 'string' ? undefined : item?.icon;
}
